// extracted by mini-css-extract-plugin
export default {"container":"LabelPreview-module__container--NXD8W"};